import { Group, Tooltip } from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { THEME_VARS, UNNAMED_OBJECT_NAME } from "../../../../utils/constants";
import type { ObjectName } from "../../../../utils/enums";
import { ComponentOpenEditModalLink } from "../../ComponentOpenEditModalLink/ComponentOpenEditModalLink";
import type { ConfiguratorComponent } from "../ComponentTable";

interface GetNameColumnProps {
  objectName: ObjectName;
  projectId: string;
  siteId: number;
}

function getNameColumn({
  objectName,
  projectId,
  siteId
}: GetNameColumnProps): MRT_ColumnDef<ConfiguratorComponent> {
  return {
    header: "Name",
    accessorKey: "name",
    minSize: 200,
    Cell: ({ row }) => (
      <NameCell
        componentId={row.original.id}
        incomplete={"complete" in row.original && !row.original?.complete}
        name={row.original.name}
        objectName={objectName}
        projectId={projectId}
        siteId={siteId}
      />
    )
  };
}

interface NameCellProps {
  componentId: number;
  name: string;
  objectName: ObjectName;
  incomplete?: boolean;
  projectId: string;
  siteId: number;
}

function NameCell({
  componentId,
  name,
  objectName,
  incomplete,
  projectId,
  siteId
}: NameCellProps) {
  const linkContent = name || UNNAMED_OBJECT_NAME;

  return (
    <Group gap="xs" wrap="nowrap">
      <ComponentOpenEditModalLink
        componentId={componentId}
        linkContent={linkContent}
        objectName={objectName}
        projectId={projectId}
        siteId={siteId}
      />
      {incomplete && (
        <Tooltip label="Diese Komponente benötigt weitere Daten zur Vervollständigung.">
          <IconAlertCircle color={THEME_VARS.error[6]} size="1.2em" />
        </Tooltip>
      )}
    </Group>
  );
}

export { getNameColumn };
